import { DEFAULT_CHART_COLORS } from './constants'

export const getColors = length => {
  const defaultColorsLength = DEFAULT_CHART_COLORS.length
  const repeatCount = Math.ceil(length / defaultColorsLength)
  return [].concat(...new Array(repeatCount).fill(DEFAULT_CHART_COLORS)).slice(0, length)
}
